import { render } from "./FavoriteChartItem.vue?vue&type=template&id=4194c260&ts=true"
import script from "./FavoriteChartItem.vue?vue&type=script&lang=ts"
export * from "./FavoriteChartItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__